import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  boughtCellularPackages: [],
  boughtAbroadPackages: [],
};

const selfCareSuccessMsgBlockSlice = createSlice({
  name: 'selfCareSuccessMsgBlock',
  initialState,
  reducers: {
    resetState: (state) => initialState,
    handleCellularPackageBought: (state, action) => {
      state.boughtCellularPackages.push(action.payload);
      return state;
    },
    removeFromBoughtCellularPackages: (state, action) => {
      state.boughtCellularPackages.splice(action.payload, 1);
    },
    saveToHistory: (state, action) => {
      return state;
    },
  },
});

export const {
  resetState,
  handleCellularPackageBought,
  removeFromBoughtCellularPackages,
  saveToHistory,
} = selfCareSuccessMsgBlockSlice.actions;

export default selfCareSuccessMsgBlockSlice.reducer;
